import CostsMenu from "./EconomicItems/CostsMenu";
import UtilizationMenu from "./EconomicItems/UtilizationMenu";

interface EconomicMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const EconomicBurdenMenu: React.FC<EconomicMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  return (
    <>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">Costs</div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <CostsMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></CostsMenu>
          </p>
        </div>
      </div>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">Utilization </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <UtilizationMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></UtilizationMenu>
          </p>
        </div>
      </div>
    </>
  );
};

export default EconomicBurdenMenu;
